var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "resportesserie" },
    [
      _c(
        "div",
        { staticClass: "flex sm12 md12" },
        [
          _c(
            "FormFieldsContainer",
            [
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.ubicacion.label,
                              items: _vm.ubicacionlist,
                              "item-text": "tipoubicaname",
                              "item-value": "tipoubicaid",
                              clearable: "",
                              required: ""
                            },
                            model: {
                              value: _vm.formFields.ubicacion.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.ubicacion, "value", $$v)
                              },
                              expression: "formFields.ubicacion.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: _vm.formFields.simnumero.label,
                              clearable: ""
                            },
                            model: {
                              value: _vm.formFields.simnumero.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.simnumero, "value", $$v)
                              },
                              expression: "formFields.simnumero.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: _vm.formFields.serienumero.label,
                              clearable: ""
                            },
                            model: {
                              value: _vm.formFields.serienumero.value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.serienumero,
                                  "value",
                                  $$v
                                )
                              },
                              expression: "formFields.serienumero.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.telco.label,
                              items: _vm.telconamelist,
                              "item-text": "telconame",
                              "item-value": "telcoid",
                              clearable: ""
                            },
                            on: { change: _vm.getPlanOptions },
                            model: {
                              value: _vm.formFields.telco.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.telco, "value", $$v)
                              },
                              expression: "formFields.telco.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _vm.formFields.telco.value
                            ? _c("v-autocomplete", {
                                attrs: {
                                  label: _vm.formFields.telcoplan.label,
                                  items: _vm.telcoplannamelist,
                                  "item-text": "telcoplanname",
                                  "item-value": "telcoplanid",
                                  clearable: "",
                                  required: ""
                                },
                                model: {
                                  value: _vm.formFields.telcoplan.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.telcoplan,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.telcoplan.value"
                                }
                              })
                            : _vm._e(),
                          !_vm.formFields.telco.value
                            ? _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.telcoplan.label,
                                  items: _vm.telcoplannamelist,
                                  "item-text": "telcoplanname",
                                  "item-value": "telcoplanid",
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.formFields.telcoplan.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.telcoplan,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.telcoplan.value"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.tipoSIM.label,
                              items: _vm.tiposim,
                              "item-text": "tipo_sim",
                              "item-value": "id",
                              clearable: "",
                              required: ""
                            },
                            model: {
                              value: _vm.formFields.tipoSIM.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.tipoSIM, "value", $$v)
                              },
                              expression: "formFields.tipoSIM.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.simestado.label,
                              items: _vm.simestadolist,
                              "item-text": "configvalor",
                              "item-value": "configid",
                              clearable: "",
                              required: ""
                            },
                            model: {
                              value: _vm.formFields.simestado.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.simestado, "value", $$v)
                              },
                              expression: "formFields.simestado.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("DatePicker", {
                            staticClass: "inputfieldform",
                            attrs: {
                              locale: "es-cl",
                              color: "primary",
                              label: _vm.formFields.dateCargaInicio.label
                            },
                            model: {
                              value: _vm.formFields.dateCargaInicio.value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.dateCargaInicio,
                                  "value",
                                  $$v
                                )
                              },
                              expression: "formFields.dateCargaInicio.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("DatePicker", {
                            staticClass: "inputfieldform",
                            attrs: {
                              locale: "es-cl",
                              color: "primary",
                              label: _vm.formFields.dateCargaFinal.label
                            },
                            model: {
                              value: _vm.formFields.dateCargaFinal.value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.dateCargaFinal,
                                  "value",
                                  $$v
                                )
                              },
                              expression: "formFields.dateCargaFinal.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c("v-flex", { attrs: { sm4: "", md4: "" } }, [
                        _c(
                          "div",
                          { staticClass: "text-sm-center botones-filtros" },
                          [
                            _c(
                              "v-btn",
                              { on: { click: _vm.handleBuscarClick } },
                              [
                                _c("v-icon", [_vm._v("search")]),
                                _vm._v("Filtrar\n              ")
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              { on: { click: _vm.clearFilters } },
                              [
                                _c("v-icon", [_vm._v("clear")]),
                                _vm._v("Limpiar\n              ")
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  flat: "",
                                  small: "",
                                  color: "primary"
                                },
                                on: { click: _vm.btn_exportar }
                              },
                              [
                                _c(
                                  "v-icon",
                                  { staticClass: "importExportBtnIcon" },
                                  [_vm._v("cloud_download")]
                                ),
                                _vm._v("  \n                "),
                                _c(
                                  "span",
                                  { staticClass: "importExportBtnTexto" },
                                  [_vm._v("Exportar"), _c("br"), _vm._v("CSV")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", {
                staticClass: "clearfix",
                staticStyle: { width: "100%" }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "gridcard rounded-card inventario-sim" },
        [
          _c("MantenedorGridSinCodigo", {
            attrs: {
              "grid-options": _vm.gridOptions,
              funcionalidadId: _vm.funcionalidad
            }
          })
        ],
        1
      ),
      _vm.showReporteGenerado
        ? _c("div", { staticClass: "wrap-evidencia" }, [
            _c(
              "div",
              { staticClass: "modalEnvio", attrs: { id: "myModal2" } },
              [
                _c("div", { staticClass: "modalEnvio-content" }, [
                  _c(
                    "div",
                    [
                      _vm._m(0),
                      _c(
                        "div",
                        {
                          staticClass: "buttonClose buttonCloseEvidencia",
                          attrs: { align: "right" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.closeReporte()
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "importExportBtnIcon" },
                                [_vm._v("close")]
                              ),
                              _vm._v("  \n              "),
                              _c(
                                "span",
                                { staticClass: "importExportBtnTexto" },
                                [_vm._v("Cerrar")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c("p", { staticStyle: { "margin-top": "40px" } }, [
                            _vm._v(_vm._s(_vm.texto_reporte))
                          ])
                        ]),
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c(
                            "p",
                            { staticStyle: { "margin-top": "40px" } },
                            [
                              _vm._v(
                                "\n                Puede ver sus reportes en el menú\n                "
                              ),
                              _c(
                                "router-link",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    "font-size": "13px"
                                  },
                                  attrs: {
                                    "active-class": "router-link-active",
                                    to: "/conecta-reportes"
                                  }
                                },
                                [_vm._v("Informes")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        : _vm._e(),
      _vm.mostrarModalVerDetalle
        ? _c("VerEditarModal", {
            attrs: {
              serieNumeroSeleccionado: _vm.serieNumeroSeleccionado,
              simestadolistSeleccionado: _vm.simestadolistSeleccionado
            },
            on: { cerrar: _vm.handleCierreModalVerDetalle }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleEvidencia" }, [
      _c("h2", { staticClass: "importExportBtnIcon" }, [
        _vm._v("Reporte Solicitado")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }